import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()

    if ('_ISRF_MAP' !== map.data.mapTypeCode) {
        return null
    }

    const onClick = () => map.isrf.createBranch()

    return {
        key: 'create-branch-from-isrf',
        label: '创建增量分支',
        onClick,
    }
}
